import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  hasFilters: boolean;
  onClear: () => void;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  hasFilters,
  onClear,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/10 px-6 py-20 text-center">
      <div className="mb-5 flex size-16 items-center justify-center rounded-2xl bg-primary/8">
        <Icon className="size-7 text-primary" />
      </div>
      <h3
        className="text-lg font-semibold text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {title}
      </h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">
          {description}
        </p>
      )}
      {hasFilters && (
        <Button variant="outline" size="sm" onClick={onClear} className="mt-4">
          Očisti filtere
        </Button>
      )}
    </div>
  );
}
